import { render, staticRenderFns } from "./detailPlayersetting.vue?vue&type=template&id=0c5797d7&scoped=true"
import script from "./detailPlayersetting.vue?vue&type=script&lang=js"
export * from "./detailPlayersetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5797d7",
  null
  
)

export default component.exports